import React from 'react';
import ReactDOM from 'react-dom';
import Doc from './components/Doc';

/**
 *
 * Documentation
 *
 *
 * To work on this locally, run:
 *     npm run start:docs
 */

ReactDOM.render(<Doc />, document.getElementById('content'));
